var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 33,
    rx: 16.5,
    fill: "url(#paint0_linear_792_3419)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5615 20.3122C23.0964 20.1747 23.4185 19.6296 23.281 19.0947L21.0396 10.3783C20.9021 9.84339 20.357 9.52128 19.8221 9.65882C19.2872 9.79636 18.9651 10.3415 19.1026 10.8764L21.095 18.6243L13.347 20.6166C12.8121 20.7542 12.49 21.2993 12.6276 21.8342C12.7651 22.369 13.3102 22.6912 13.8451 22.5536L22.5615 20.3122ZM12.1788 14.5172L21.8038 20.2047L22.8212 18.4828L13.1962 12.7953L12.1788 14.5172Z",
    fill: "#1C2E1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_792_3419",
    x1: 26.0849,
    y1: -3.75517,
    x2: -3.49242,
    y2: 14.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FFD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BFC87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/ExpandArrow.b9b87ee7a867e1e7e6f5b79c3ff1a45f.svg";
export { ForwardRef as ReactComponent };